import { render, staticRenderFns } from "./EditCallCenter.vue?vue&type=template&id=8581e97e&scoped=true"
import script from "./EditCallCenter.vue?vue&type=script&lang=js"
export * from "./EditCallCenter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8581e97e",
  null
  
)

export default component.exports